import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BKJIcon } from '../BKJIcon/index.js';
import { AlertText, BKJAlertWrapper, DismissButton, IconWrapper } from './BKJAlert.styled.js';
const iconMap = {
    dismissable: _jsx(BKJIcon, { iconName: "ClientPreferences", fontSize: 24 }),
    warning: _jsx(BKJIcon, { iconName: "Warning", fontSize: 24 }),
    conflict: _jsx(BKJIcon, { iconName: "Error", fontSize: 24 }),
};
export const BKJAlert = ({ status, onDismiss, children, ...rest }) => {
    return (_jsxs(BKJAlertWrapper, { ...rest, children: [_jsx(IconWrapper, { children: iconMap[status] }), _jsx(AlertText, { status: status, children: children }), status === 'dismissable' && _jsx(DismissButton, { onClick: onDismiss, children: "Dismiss" })] }));
};
//# sourceMappingURL=BKJAlert.js.map